import {View, StyleSheet} from 'react-native';
import Text from '../../../components/Text';
import React from 'react';
import {Card} from 'react-native-paper';
import {KeyLog} from '../types';

export default function KeyLogItem({
  keyLog,
  itemClickHandler,
}: {
  keyLog: KeyLog;
  itemClickHandler: () => void;
}) {
  const keyIsOut = keyLog.status === 'Out';
  const keyIsReturned = keyLog.status === 'Returned';

  return (
    <Card style={styles.card} onPress={() => itemClickHandler()}>
      <View style={styles.container}>
        <View style={styles.textContainer}>
          <Text>{`Status - ${keyLog.status}`}</Text>
          <Text>{`${keyLog.keysOnRing} Keys on ring `}</Text>
          {keyIsOut && (
            <>
              <Text>
                {`Give by ${keyLog.whoGaveKey?.firstName} ${
                  keyLog.whoGaveKey?.lastName
                } to ${keyLog.keyGivenTo} on ${new Date(
                  keyLog.keyDateTimeOut,
                ).toLocaleDateString()}`}
              </Text>
              <Text>
                {`To be returned before ${new Date(
                  keyLog.expectedReturnDatTime,
                ).toLocaleDateString()}`}
              </Text>
            </>
          )}
          {keyIsReturned && (
            <Text>
              {`Returned  by ${keyLog.whoPutKeyBack?.firstName} ${
                keyLog.whoPutKeyBack?.lastName
              } to ${keyLog.keyGivenTo} on ${new Date(
                keyLog.keyDateTimeIn,
              ).toLocaleDateString()}`}
            </Text>
          )}
        </View>
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 8,
    marginVertical: 8,
  },
  container: {
    flexDirection: 'row',
    padding: 8,
    marginVertical: 4,
    justifyContent: 'space-between',
  },
  textContainer: {
    flex: 1,
    marginLeft: 8,
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
});
